var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{attrs:{"id":"jump-to-header"}},[_vm._v(_vm._s(_vm.heading || "View"))]),_c('feature-show',{attrs:{"id":_vm.id}}),_c('polymorphic-reference-card-index',{attrs:{"filtering":_vm.filtering_reference}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }